import { auth } from "./firebase";

// Capture the identity before asynchronous work. Unowned legacy keys stay intact,
// but are never adopted by whichever account happens to sign in next.
export function accountStorage() {
  const user = auth?.currentUser;
  const uid = user?.uid;
  const isCurrent = () => !!uid && auth.currentUser === user;
  const key = (name) => `axoris.account.${encodeURIComponent(uid)}.${name}`;
  return {
    uid, isCurrent,
    read(name, fallback) {
      if (!isCurrent()) return fallback;
      try { return JSON.parse(localStorage.getItem(key(name))) ?? fallback; }
      catch { return fallback; }
    },
    write(name, value) {
      if (!isCurrent()) return false;
      localStorage.setItem(key(name), JSON.stringify(value));
      return true;
    },
  };
}
